import './main.css'
import { Card } from './Components/Cards/Card'
import { ShopCard } from './Components/Cards/ShopCard'
import { WindowDesign } from './Components/WindowDesign'
import { useEffect, useState } from 'react'
import { RecipeCard } from './Components/Cards/Recipe'
import { OptionFilterCountry } from './Components/Inputs/InputFilterCountry'
import { InputFilterDisease } from './Components/Inputs/InputFilterDisease'
import { ArchiveIcon, BackIcon, BrainIcon } from './Components/Icons/Icons'

export function App () {
  const [ShopP, setShopP] = useState([
    { id: '1', name: 'Carne de res', mount: 500, form: 'g' },
    { id: '2', name: 'Cebolla', mount: 2, form: 'unidades' },
    { id: '3', name: 'Pimiento verde', mount: 1, form: 'unidad' },
    { id: '4', name: 'Tomate', mount: 4, form: 'unidades' },
    { id: '5', name: 'Pollo', mount: 500, form: 'g' },
    { id: '6', name: 'Arroz', mount: 200, form: 'g' },
    { id: '7', name: 'Pimiento rojo', mount: 1, form: 'unidad' },
    { id: '8', name: 'Guisantes', mount: 100, form: 'g' },
    { id: '9', name: 'Yuca', mount: 500, form: 'g' },
    { id: '10', name: 'Ajo', mount: 2, form: 'unidades' },
    { id: '11', name: 'Aceite de oliva', mount: 50, form: 'ml' },
    { id: '12', name: 'Limón', mount: 2, form: 'unidades' },
    { id: '13', name: 'Frijoles negros', mount: 200, form: 'g' },
    { id: '14', name: 'Carne molida', mount: 500, form: 'g' },
    { id: '15', name: 'Maíz', mount: 2, form: 'mazorcas' },
    { id: '16', name: 'Calabaza', mount: 200, form: 'g' },
    { id: '17', name: 'Plátano verde', mount: 4, form: 'unidades' },
    { id: '18', name: 'Aceite', mount: 500, form: 'ml' },
    { id: '19', name: 'Sal', mount: 1, form: 'cdta' },
    { id: '20', name: 'Jamón', mount: 200, form: 'g' },
    { id: '21', name: 'Harina', mount: 100, form: 'g' },
    { id: '22', name: 'Leche', mount: 500, form: 'ml' },
    { id: '23', name: 'Huevo', mount: 4, form: 'unidades' },
    { id: '24', name: 'Azúcar', mount: 200, form: 'g' },
    { id: '25', name: 'Chicharrón', mount: 100, form: 'g' },
    { id: '26', name: 'Tocino', mount: 200, form: 'g' },
    { id: '27', name: 'Chorizo', mount: 100, form: 'g' },
    { id: '28', name: 'Papas', mount: 300, form: 'g' },
    { id: '29', name: 'Nabos', mount: 200, form: 'g' }
  ]
  ) // AGG: Ingredientes (NO OLVIDAR TENER IGUALES LA Shop Y LA ShopP)
  const [Shop, setShop] = useState([
    { id: '1', name: 'Carne de res', mount: 500, form: 'g' },
    { id: '2', name: 'Cebolla', mount: 2, form: 'unidades' },
    { id: '3', name: 'Pimiento verde', mount: 1, form: 'unidad' },
    { id: '4', name: 'Tomate', mount: 4, form: 'unidades' },
    { id: '5', name: 'Pollo', mount: 500, form: 'g' },
    { id: '6', name: 'Arroz', mount: 200, form: 'g' },
    { id: '7', name: 'Pimiento rojo', mount: 1, form: 'unidad' },
    { id: '8', name: 'Guisantes', mount: 100, form: 'g' },
    { id: '9', name: 'Yuca', mount: 500, form: 'g' },
    { id: '10', name: 'Ajo', mount: 2, form: 'unidades' },
    { id: '11', name: 'Aceite de oliva', mount: 50, form: 'ml' },
    { id: '12', name: 'Limón', mount: 2, form: 'unidades' },
    { id: '13', name: 'Frijoles negros', mount: 200, form: 'g' },
    { id: '14', name: 'Carne molida', mount: 500, form: 'g' },
    { id: '15', name: 'Maíz', mount: 2, form: 'mazorcas' },
    { id: '16', name: 'Calabaza', mount: 200, form: 'g' },
    { id: '17', name: 'Plátano verde', mount: 4, form: 'unidades' },
    { id: '18', name: 'Aceite', mount: 500, form: 'ml' },
    { id: '19', name: 'Sal', mount: 1, form: 'cdta' },
    { id: '20', name: 'Jamón', mount: 200, form: 'g' },
    { id: '21', name: 'Harina', mount: 100, form: 'g' },
    { id: '22', name: 'Leche', mount: 500, form: 'ml' },
    { id: '23', name: 'Huevo', mount: 4, form: 'unidades' },
    { id: '24', name: 'Azúcar', mount: 200, form: 'g' },
    { id: '25', name: 'Chicharrón', mount: 100, form: 'g' },
    { id: '26', name: 'Tocino', mount: 200, form: 'g' },
    { id: '27', name: 'Chorizo', mount: 100, form: 'g' },
    { id: '28', name: 'Papas', mount: 300, form: 'g' },
    { id: '29', name: 'Nabos', mount: 200, form: 'g' }
  ]
  ) // AGG: Ingredientes (NO OLVIDAR TENER IGUALES LA Shop Y LA ShopP)

  const [FreeRecipes, setFreeRecipes] = useState([])
  const [ClockRecipes, setClockRecipes] = useState([])

  const recipes = [
    { id: 1, name: 'Ropa Vieja', filterKindFood: '', filterDiseases: [], ingredientes: [{ name: 'Carne de res', mount: 500, form: 'g' }, { name: 'Cebolla', mount: 2, form: 'unidades' }, { name: 'Pimiento verde', mount: 1, form: 'unidad' }, { name: 'Tomate', mount: 4, form: 'unidades' }] },
    { id: 2, name: 'Arroz con Pollo', filterKindFood: '', filterDiseases: [], ingredientes: [{ name: 'Pollo', mount: 500, form: 'g' }, { name: 'Arroz', mount: 200, form: 'g' }, { name: 'Pimiento rojo', mount: 1, form: 'unidad' }, { name: 'Guisantes', mount: 100, form: 'g' }] },
    { id: 3, name: 'Yuca con Mojo', filterKindFood: 'Veg', filterDiseases: [], ingredientes: [{ name: 'Yuca', mount: 500, form: 'g' }, { name: 'Ajo', mount: 1, form: 'unidades' }, { name: 'Aceite de oliva', mount: 50, form: 'ml' }, { name: 'Limón', mount: 2, form: 'unidades' }] },
    { id: 4, name: 'Moros y Cristianos', filterKindFood: 'Veg', filterDiseases: [], ingredientes: [{ name: 'Frijoles negros', mount: 200, form: 'g' }, { name: 'Arroz', mount: 200, form: 'g' }, { name: 'Cebolla', mount: 1, form: 'unidad' }, { name: 'Ajo', mount: 1, form: 'unidades' }] },
    { id: 5, name: 'Vaca Frita', filterKindFood: 'Car', filterDiseases: [], ingredientes: [{ name: 'Carne de res', mount: 500, form: 'g' }, { name: 'Cebolla', mount: 2, form: 'unidades' }, { name: 'Limón', mount: 2, form: 'unidades' }, { name: 'Ajo', mount: 1, form: 'unidades' }] },
    { id: 6, name: 'Tostones', filterKindFood: 'Veg', filterDiseases: [], ingredientes: [{ name: 'Plátano verde', mount: 4, form: 'unidades' }, { name: 'Aceite', mount: 500, form: 'ml' }, { name: 'Sal', mount: 1, form: 'cdta' }] },
    { id: 7, name: 'Picadillo a la Habanera', filterKindFood: '', filterDiseases: [], ingredientes: [{ name: 'Carne molida', mount: 500, form: 'g' }, { name: 'Cebolla', mount: 1, form: 'unidad' }, { name: 'Ajo', mount: 1, form: 'unidades' }, { name: 'Tomate', mount: 2, form: 'unidades' }] },
    { id: 8, name: 'Ajiaco', filterKindFood: '', filterDiseases: [], ingredientes: [{ name: 'Cerdo', mount: 200, form: 'g' }, { name: 'Maíz', mount: 2, form: 'mazorcas' }, { name: 'Yuca', mount: 200, form: 'g' }, { name: 'Calabaza', mount: 200, form: 'g' }] },
    { id: 9, name: 'Ensalada de Aguacate', filterKindFood: 'Veg', filterDiseases: [], ingredientes: [{ name: 'Aguacate', mount: 2, form: 'unidades' }, { name: 'Cebolla', mount: 1, form: 'unidad' }, { name: 'Limón', mount: 2, form: 'unidades' }, { name: 'Aceite de oliva', mount: 50, form: 'ml' }] },
    { id: 10, name: 'Fufú de Plátano', filterKindFood: 'Veg', filterDiseases: [], ingredientes: [{ name: 'Plátano maduro', mount: 4, form: 'unidades' }, { name: 'Ajo', mount: 1, form: 'unidades' }, { name: 'Chicharrón', mount: 100, form: 'g' }, { name: 'Aceite', mount: 50, form: 'ml' }] },
    { id: 11, name: 'Relleno de Papa', filterKindFood: '', filterDiseases: [], ingredientes: [{ name: 'Papa', mount: 500, form: 'g' }, { name: 'Carne molida', mount: 300, form: 'g' }, { name: 'Cebolla', mount: 1, form: 'unidad' }, { name: 'Ajo', mount: 1, form: 'unidades' }] },
    { id: 12, name: 'Croquetas de Jamón', filterKindFood: 'Car', filterDiseases: [], ingredientes: [{ name: 'Jamón', mount: 200, form: 'g' }, { name: 'Harina', mount: 100, form: 'g' }, { name: 'Leche', mount: 500, form: 'ml' }, { name: 'Huevo', mount: 2, form: 'unidades' }] },
    { id: 13, name: 'Tamal en Cazuela', filterKindFood: '', filterDiseases: [], ingredientes: [{ name: 'Maíz', mount: 500, form: 'g' }, { name: 'Carne de cerdo', mount: 200, form: 'g' }, { name: 'Cebolla', mount: 1, form: 'unidad' }, { name: 'Ajo', mount: 1, form: 'unidades' }] },
    { id: 14, name: 'Flan de Coco', filterKindFood: 'Veg', filterDiseases: ['Diabetes'], ingredientes: [{ name: 'Leche condensada', mount: 1, form: 'lata' }, { name: 'Leche de coco', mount: 200, form: 'ml' }, { name: 'Huevo', mount: 4, form: 'unidades' }, { name: 'Azúcar', mount: 200, form: 'g' }] },
    { id: 15, name: 'Caldo Gallego', filterKindFood: '', filterDiseases: [], ingredientes: [{ name: 'Tocino', mount: 200, form: 'g' }, { name: 'Chorizo', mount: 100, form: 'g' }, { name: 'Papas', mount: 300, form: 'g' }, { name: 'Nabos', mount: 200, form: 'g' }] },
    { id: 16, name: 'Dulce de Coco', filterKindFood: 'Veg', filterDiseases: ['Diabetes'], ingredientes: [{ name: 'Coco rallado', mount: 300, form: 'g' }, { name: 'Azúcar', mount: 200, form: 'g' }, { name: 'Agua', mount: 100, form: 'ml' }] },
    { id: 17, name: 'Turrón de Maní', filterKindFood: 'Veg', filterDiseases: ['Alergia al maní'], ingredientes: [{ name: 'Maní', mount: 200, form: 'g' }, { name: 'Azúcar', mount: 150, form: 'g' }, { name: 'Miel', mount: 50, form: 'g' }] },
    { id: 18, name: 'Buñuelos', filterKindFood: 'Veg', filterDiseases: [], ingredientes: [{ name: 'Yuca', mount: 300, form: 'g' }, { name: 'Harina', mount: 100, form: 'g' }, { name: 'Huevos', mount: 2, form: 'unidades' }, { name: 'Anís', mount: 1, form: 'cdta' }] },
    { id: 19, name: 'Natilla', filterKindFood: 'Veg', filterDiseases: ['Intolerancia la lactosa'], ingredientes: [{ name: 'Leche', mount: 500, form: 'ml' }, { name: 'Azúcar', mount: 150, form: 'g' }, { name: 'Huevo', mount: 4, form: 'unidades' }, { name: 'Maicena', mount: 50, form: 'g' }] },
    { id: 20, name: 'Cascos de Guayaba', filterKindFood: 'Veg', filterDiseases: [], ingredientes: [{ name: 'Guayaba', mount: 500, form: 'g' }, { name: 'Azúcar', mount: 200, form: 'g' }, { name: 'Agua', mount: 500, form: 'ml' }] },
    { id: 21, name: 'Pastelitos de Guayaba', filterKindFood: '', filterDiseases: [], ingredientes: [{ name: 'Masa de hojaldre', mount: 500, form: 'g' }, { name: 'Pasta de guayaba', mount: 200, form: 'g' }, { name: 'Azúcar', mount: 50, form: 'g' }] },
    { id: 22, name: 'Tarta de Santiago', filterKindFood: 'Veg', filterDiseases: [], ingredientes: [{ name: 'Almendras', mount: 200, form: 'g' }, { name: 'Azúcar', mount: 200, form: 'g' }, { name: 'Huevos', mount: 4, form: 'unidades' }, { name: 'Ralladura de limón', mount: 1, form: 'unidad' }] },
    { id: 23, name: 'Flan de Caramelo', filterKindFood: '', filterDiseases: ['Diabetes'], ingredientes: [{ name: 'Leche condensada', mount: 1, form: 'lata' }, { name: 'Huevo', mount: 4, form: 'unidades' }, { name: 'Azúcar', mount: 150, form: 'g' }] },
    { id: 24, name: 'Casquitos de Mamey', filterKindFood: 'Veg', filterDiseases: [], ingredientes: [{ name: 'Mamey', mount: 500, form: 'g' }, { name: 'Azúcar', mount: 200, form: 'g' }, { name: 'Agua', mount: 500, form: 'ml' }] },
    { id: 25, name: 'Empanadas de Boniato', filterKindFood: 'Veg', filterDiseases: [], ingredientes: [{ name: 'Boniato', mount: 300, form: 'g' }, { name: 'Azúcar', mount: 100, form: 'g' }, { name: 'Masa de empanada', mount: 500, form: 'g' }] },
    { id: 26, name: 'Helado de Mango', filterKindFood: 'Veg', filterDiseases: [], ingredientes: [{ name: 'Mango', mount: 500, form: 'g' }, { name: 'Azúcar', mount: 200, form: 'g' }, { name: 'Leche', mount: 500, form: 'ml' }] },
    { id: 27, name: 'Pudín de Pan', filterKindFood: 'Veg', filterDiseases: [], ingredientes: [{ name: 'Pan', mount: 300, form: 'g' }, { name: 'Leche', mount: 500, form: 'ml' }, { name: 'Azúcar', mount: 150, form: 'g' }, { name: 'Huevo', mount: 4, form: 'unidades' }] },
    { id: 28, name: 'Galleticas de Morón', filterKindFood: 'Veg', filterDiseases: [], ingredientes: [{ name: 'Harina', mount: 300, form: 'g' }, { name: 'Azúcar', mount: 150, form: 'g' }, { name: 'Mantequilla', mount: 200, form: 'g' }] },
    { id: 29, name: 'Turrón de Coco', filterKindFood: 'Veg', filterDiseases: ['Diabetes'], ingredientes: [{ name: 'Coco rallado', mount: 300, form: 'g' }, { name: 'Azúcar', mount: 200, form: 'g' }, { name: 'Miel', mount: 50, form: 'g' }] },
    { id: 30, name: 'Dulce de Leche', filterKindFood: 'Veg', filterDiseases: ['Diabetes'], ingredientes: [{ name: 'Leche condensada', mount: 1, form: 'lata' }, { name: 'Azúcar', mount: 200, form: 'g' }] },
    { id: 31, name: 'Mojito', filterKindFood: 'Veg', filterDiseases: [], ingredientes: [{ name: 'Ron blanco', mount: 50, form: 'ml' }, { name: 'Hierbabuena', mount: 5, form: 'hojas' }, { name: 'Azúcar', mount: 2, form: 'cdtas' }, { name: 'Agua con gas', mount: 100, form: 'ml' }] },
    { id: 32, name: 'Daiquiri', filterKindFood: 'Veg', filterDiseases: [], ingredientes: [{ name: 'Ron blanco', mount: 60, form: 'ml' }, { name: 'Jugo de limón', mount: 25, form: 'ml' }, { name: 'Azúcar', mount: 1, form: 'cdta' }, { name: 'Hielo', mount: 1, form: 'taza' }] },
    { id: 33, name: 'Cuba Libre', filterKindFood: '', filterDiseases: [], ingredientes: [{ name: 'Ron', mount: 50, form: 'ml' }, { name: 'Coca-Cola', mount: 150, form: 'ml' }, { name: 'Limón', mount: 1, form: 'rodaja' }] },
    { id: 34, name: 'Piña Colada', filterKindFood: '', filterDiseases: [], ingredientes: [{ name: 'Ron blanco', mount: 50, form: 'ml' }, { name: 'Jugo de piña', mount: 100, form: 'ml' }, { name: 'Leche de coco', mount: 50, form: 'ml' }, { name: 'Hielo', mount: 1, form: 'taza' }] },
    { id: 35, name: 'Guarapo', filterKindFood: 'Veg', filterDiseases: [], ingredientes: [{ name: 'Jugo de caña de azúcar', mount: 200, form: 'ml' }, { name: 'Hielo', mount: 1, form: 'taza' }] },
    { id: 36, name: 'Jugo de Mango', filterKindFood: 'Veg', filterDiseases: [], ingredientes: [{ name: 'Mango', mount: 2, form: 'unidades' }, { name: 'Agua', mount: 200, form: 'ml' }, { name: 'Azúcar', mount: 2, form: 'cdtas' }] },
    { id: 37, name: 'Café Cubano', filterKindFood: 'Veg', filterDiseases: [], ingredientes: [{ name: 'Café', mount: 2, form: 'cdtas' }, { name: 'Agua', mount: 100, form: 'ml' }, { name: 'Azúcar', mount: 1, form: 'cdta' }] },
    { id: 38, name: 'Batido de Guayaba', filterKindFood: 'Veg', filterDiseases: [], ingredientes: [{ name: 'Guayaba', mount: 2, form: 'unidades' }, { name: 'Leche', mount: 200, form: 'ml' }, { name: 'Azúcar', mount: 2, form: 'cdtas' }] },
    { id: 39, name: 'Agua de Coco', filterKindFood: 'Veg', filterDiseases: [], ingredientes: [{ name: 'Agua de coco', mount: 200, form: 'ml' }] },
    { id: 40, name: 'Jugo de Tamarindo', filterKindFood: 'Veg', filterDiseases: [], ingredientes: [{ name: 'Tamarindo', mount: 100, form: 'g' }, { name: 'Agua', mount: 200, form: 'ml' }, { name: 'Azúcar', mount: 2, form: 'cdtas' }] },
    { id: 41, name: 'Canchánchara', filterKindFood: 'Veg', filterDiseases: [], ingredientes: [{ name: 'Ron', mount: 50, form: 'ml' }, { name: 'Miel', mount: 1, form: 'cdta' }, { name: 'Jugo de limón', mount: 25, form: 'ml' }, { name: 'Agua', mount: 100, form: 'ml' }] },
    { id: 42, name: 'Coctel de Plátano', filterKindFood: 'Veg', filterDiseases: [], ingredientes: [{ name: 'Plátano maduro', mount: 1, form: 'unidad' }, { name: 'Ron blanco', mount: 50, form: 'ml' }, { name: 'Leche', mount: 200, form: 'ml' }, { name: 'Azúcar', mount: 2, form: 'cdtas' }] },
    { id: 43, name: 'Ponche Crema', filterKindFood: '', filterDiseases: [], ingredientes: [{ name: 'Leche condensada', mount: 1, form: 'lata' }, { name: 'Ron', mount: 50, form: 'ml' }, { name: 'Huevo', mount: 1, form: 'unidad' }, { name: 'Azúcar', mount: 2, form: 'cdtas' }] },
    { id: 44, name: 'Batido de Mamey', filterKindFood: 'Veg', filterDiseases: [], ingredientes: [{ name: 'Mamey', mount: 2, form: 'unidades' }, { name: 'Leche', mount: 200, form: 'ml' }, { name: 'Azúcar', mount: 2, form: 'cdtas' }] },
    { id: 45, name: 'Refresco de Guanábana', filterKindFood: 'Veg', filterDiseases: [], ingredientes: [{ name: 'Guanábana', mount: 200, form: 'g' }, { name: 'Agua', mount: 200, form: 'ml' }, { name: 'Azúcar', mount: 2, form: 'cdtas' }] },
    { id: 46, name: 'Champola de Frutas', filterKindFood: 'Veg', filterDiseases: [], ingredientes: [{ name: 'Frutas variadas', mount: 300, form: 'g' }, { name: 'Leche', mount: 200, form: 'ml' }, { name: 'Azúcar', mount: 2, form: 'cdtas' }] }
  ]
  // AGG: Recetas

  const FlanReadRecipe = () => (
    <>
     <h5>Flan</h5>
      <p>Ingredientes</p>
      <div>
        <p>1000</p>
      </div>
    </>

  )
  const ReadRecipes = [
    { id: 1, name: 'Flan', component: FlanReadRecipe }
  ]

  const Diseases = ['Diabetes', 'Gastritis', 'Intolerancia la lactosa', 'Alergia al maní'] // AGG: Enfermedades

  const [filtersCountry, setFiltersCountry] = useState(['Cuba', 'España', 'Italia', 'China'])

  const [inventario, setInventario] = useState([

  ])

  const [Start, setStart] = useState(false)
  const [Generated, setGenerated] = useState(false)
  const [WantClockRecipes, setWantClockRecipes] = useState(false)

  const [FormSended, setFormSended] = useState(false)

  const [PrefVegetarian, setPrefVegetarian] = useState(false)
  const [PrefMeater, setPrefMeater] = useState(false)
  const [PrefOmn, setPrefOmn] = useState(false)

  const [FilterDiseases, setFilterDiseases] = useState([])

  const [FilterNo, setFilterNo] = useState(false)
  const [FilterYes, setFilterYes] = useState(false)
  const [FilterCountry, setFilterCountry] = useState(false)

  const [Reading, setReading] = useState(false)
  const [ReadRecipe, setReadRecipe] = useState('')

  const [ResponsiveInventarioUI, setResponsiveInventarioUI] = useState(false)

  useEffect(() => {

  }, [PrefVegetarian, PrefMeater, PrefOmn])

  const TutoClickYes = () => {
    setStart(true)
  }

  const ChangePref = (pref) => {
    if (pref === 'Veg') {
      setPrefVegetarian(!PrefVegetarian)
      setPrefMeater(false)
      setPrefOmn(false)
    } else if (pref === 'Car') {
      setPrefMeater(!PrefMeater)
      setPrefOmn(false)
      setPrefVegetarian(false)
    } else if (pref === 'Omn') {
      setPrefOmn(!PrefOmn)
      setPrefVegetarian(false)
      setPrefMeater(false)
    }
  }

  const ChangeCountry = (country) => {
    if (country) {
      setFilterYes(!FilterYes)
      setFilterNo(false)
      return
    }
    setFilterYes(false)
    setFilterNo(!FilterNo)
  }

  const HandleClickFormSend = () => {
    setFormSended(true)
  }

  const HandleClickWantClockRecipe = () => {
    setWantClockRecipes(!WantClockRecipes)
  }

  const HandleSearch = (ref) => {
    const text = ref.target.value
    const newShop = []
    ShopP.forEach((item) => {
      console.log(item.name.slice(0, text.length))

      if ((item.name.slice(0, text.length).toLowerCase() === text.toLowerCase()) || (item.name.includes(text.toLowerCase()))) {
        newShop.push(item)
      }
    })

    setShop(newShop)
  }

  const Generator = () => {
    const newFreeRecipe = []
    const newClockRecipe = []
    let ClockIngredients = []
    let comprobador = 0
    let comprobadorClock = 0
    let final = -1
    let finalClock = -1

    recipes.forEach(recipe => {
      recipe.ingredientes.forEach(needIngred => {
        inventario.forEach(element => {
          if (needIngred.name === element.name) {
            comprobadorClock += 1
            if (needIngred.mount <= element.mount) {
              comprobador += 1
            } else {
              ClockIngredients.push(element.name)
            }
          }
        })

        if (comprobador === recipe.ingredientes.length) {
          final = recipe
          newFreeRecipe.push(final)
        }

        if (comprobadorClock === recipe.ingredientes.length) {
          finalClock = recipe

          finalClock.ingredientes.forEach((element) => {
            ClockIngredients.forEach((clockIngredient) => {
              if (element.name === clockIngredient) {
                element.clock = 1
                finalClock.clock = 1
              }
            })
          })

          console.log(finalClock)
          newClockRecipe.push(finalClock)
        }
      })
      comprobador = 0
      comprobadorClock = 0
      ClockIngredients = []
    })

    setFreeRecipes(AplicateFilters(newFreeRecipe))
    setClockRecipes(AplicateFilters(newClockRecipe))
    setGenerated(true)
  }

  useEffect(() => {
    console.log(FreeRecipes)
  }, [FreeRecipes])

  const AplicateFilters = (recipes) => {
    const diseaseRecipe = []
    const returnRecipe = []

    let authorized = true

    recipes.forEach(recipe => {
      recipe.filterDiseases.forEach((diseases) => {
        FilterDiseases.forEach((filter) => {
          if (diseases === filter) {
            authorized = false
          }
        })
      })
      if (authorized) {
        diseaseRecipe.push(recipe)
      }
      authorized = true
    })

    diseaseRecipe.forEach((recipe) => {
      if (PrefVegetarian) {
        if (recipe.filterKindFood === 'Veg') {
          returnRecipe.push(recipe)
        }
      } else if (PrefMeater) {
        if (recipe.filterKindFood === 'Car') {
          returnRecipe.push(recipe)
        }
      } else {
        returnRecipe.push(recipe)
      }
    })

    return returnRecipe
  }

  const HandleSelectFilterCountry = (ref) => {
    setFilterCountry(ref.target.value)
  }

  const HandleClickBackButtonToFormToGenerated = () => {
    if (Generated) {
      setGenerated(false)
      return
    }

    setStart(true)
    setFormSended(false)
  }

  const HandleClickBackButtonToWelcome = () => {
    setStart(false)
  }

  return (

    <>
      <section className='flex items-center bg-[#272727] w-screen h-screen max-xl:justify-center max-[1280px]:items-start'>

                {/*
                Seccion de la izquierda
                */}
        <section className='bg-[#353535] w-1/4 h-[93%] rounded-3xl border-2 border-[#737373] ml-2 max-xl:hidden'>
          <div className='flex justify-between bg-[#292929] items-center rounded-3xl pr-4'>

            <h5 className='text-center text-[#E3E3E3] text-2xl w-fit py-2 px-5'>Inventario</h5>

            <WindowDesign Class={'flex gap-1 items-center group-hover:py-4'}/>

          </div>

          <div className='mx-auto w-11/12 h-full max-h-[90%] bg-[#272727] p-2 rounded-xl pb-6 mt-3'>

            <div className='flex flex-col gap-2 w-full h-fit px-5 py-4 p-2 rounded-xl max-h-full overflow-y-scroll scrollbar-thin scrollbar-thumb-[#f34e00] hover:scrollbar-thumb-[#f34d00da] active:scrollbar-thumb-sky-300 scrollbar-track-slate-900 '>

              {
                inventario.map((item) => (
                  <Card key={item.id} ID={item.id} name={item.name} mount={item.mount} form={item.form} shop={Shop} setShop={setShop} inven={inventario} setInven={setInventario} />
                ))
              }

            </div>
          </div>
        </section>

                {/*
                Seccion del medio
                */}

        <section className='w-7/12 h-full py-4 max-xl:w-full '>
          <div className={!FormSended || Reading || ResponsiveInventarioUI ? 'flex-col bg-[#313131] mx-auto gap-4 flex items-start px-4 rounded-2xl h-[100%] w-11/12 transition-all duration-500 ease-in-out ' : 'flex-col bg-[#313131] w-4/5 mx-auto gap-4 h-16 flex items-start px-4 rounded-2xl w-11/12s transition-all duration-500 ease-in-out'}>
            <div className='flex justify-between h-16 w-full max-[1280px]:items-center max-[1280px]:mt-2'>
              <div className='flex items-center gap-4 h-14 max-[1280px]:h-10 max-[1280px]:gap-2'>
                <img src="Logo.png" alt="" className='h-full'/>
                <h1 className=' text-center text-3xl font-extrabold max-[1280px]:text-2xl'>GastroGuía</h1>
              </div>

              <WindowDesign Class={'flex h-full gap-1 items-center group-hover:py-4'}/>

            </div>

            <section className={Start ? 'hidden' : ''}>
              <h1 className='text-3xl font-bold mt-36 max-[1280px]:text-2xl max-[1280px]:text-center'>Bienvenido a GastroGuia</h1>
              <p className='mt-8 p-3 max-[1280px]:mt-0.5 max-[1280px]:text-center'>Antes de que empecemos con la generación de tus planes. ¿Sabes ya cómo funciona GastroGuia? Si la respuesta es "No", no te preocupes, te enseñaré.</p>

              <div className='flex gap-2 w-4/5 justify-end max-[1280px]:justify-center max-[1280px]:w-3/5 max-[1280px]:mx-auto max-[1280px]:gap-12'>
                <button className='bg-[#f34d00da] rounded-xl px-3 py-1'>No</button>
                <button className='bg-[#f34d00da] rounded-xl px-3 py-1' onClick={TutoClickYes}>Sí</button>
              </div>
            </section>

            <section className={Start && !FormSended ? 'flex flex-col w-full h-full justify-between max-[1280px]:justify-start' : 'hidden'}>

              <div className={Start && !FormSended ? 'flex flex-col mt-8 p-3 gap-5 opacity-100 transition-all overflow-y-auto h-[89%] duration-1000 ease-in-out max-[1280px]:h-fit' : 'hidden'}>

                <h1 className={Start && !FormSended ? 'text-3xl font-bold text-white mb-7 max-[1280px]:mb-2 max-[1280px]:text-2xl' : 'hidden'}>Perfecto, empecemos:</h1>

                <p className='text-2xl max-[1280px]:text-xl'>¿Tienes alguna enfermedad?</p>

                <div className='flex flex-col gap-3'>
                  {
                    Diseases.map((disease) => (
                      <InputFilterDisease key={disease} name={disease} diseases={FilterDiseases} setDiseases={setFilterDiseases}/>
                    ))
                  }
                </div>

                <p className='text-2xl max-[1280px]:text-xl'>¿Tienes alguna preferencia en comidas?</p>

                <div className='flex flex-col gap-3'>
                  <div className='flex gap-1 items-center'>
                    <input type="checkbox" name="" id="" checked={PrefVegetarian} onClick={() => ChangePref('Veg')}/> <p>Vegetariano</p>
                  </div>

                  <div className='flex gap-1 items-center'>
                    <input type="checkbox" name="" id="" checked={PrefMeater} onClick={() => ChangePref('Car')}/> <p>Carnivoro</p>
                  </div>

                  <div className='flex gap-1 items-center'>
                    <input type="checkbox" name="" id="" checked={PrefOmn} onClick={() => ChangePref('Omn')}/> <p>Omnivoro</p>
                  </div>
                </div>

                {/* <p className='text-2xl'>¿Quieres recetas de algún país en específico?</p>

                <div className='flex flex-col gap-3'>
                  <div className='flex gap-1 items-center'>
                    <input type="checkbox" name="" id="" checked={FilterYes} onClick={() => ChangeCountry(true)}/> <p>Si</p>
                  </div>

                  <div className='flex gap-1 items-center'>
                    <select onChange={HandleSelectFilterCountry} name="" id="" className='bg-[#313131]' disabled={!FilterYes}>
                      {filtersCountry.map(country => (
                        <OptionFilterCountry key={country} country={country} />
                      ))}
                    </select>
                  </div>

                  <div className='flex gap-1 items-center'>
                    <input type="checkbox" name="" id="" checked={FilterNo} onClick={() => ChangeCountry(false)}/> <p>No</p>
                  </div>

                </div> */}

              </div>

              <div className='w-full flex justify-between px-8 mb-4'>

                <div className={Start && !FormSended ? 'flex justify-end' : 'hidden'}>
                  <button className='flex gap-0.5 rounded-3xl bg-[#f34d00da] p-2' onClick={HandleClickBackButtonToWelcome}><BackIcon/>Volver</button>
                </div>
                <div className={Start && !FormSended ? 'flex justify-end' : 'hidden'}>
                  <button className='rounded-3xl bg-[#f34d00da] p-2' onClick={HandleClickFormSend}>Aceptar</button>
                </div>
              </div>
            </section>

            <section className={Reading ? 'flex flex-col w-full h-full justify-between' : 'hidden'}>
              <div>
                {ReadRecipes.map((recipe) => {
                  if (recipe.name === ReadRecipe) {
                    console.log(ReadRecipe)
                    return (<recipe.component key={recipe.id} />)
                  }
                  return null
                })}
              </div>

              <div className='mb-4'>
                <button onClick={() => { setReading(false) }} className='flex gap-0.5 rounded-full px-1.5 py-2 bg-[#f34e00]'><BackIcon/> Volver</button>
              </div>
            </section>

            <section className={ResponsiveInventarioUI ? 'w-full h-full' : 'hidden'}>

              <div className='w-full flex justify-between px-5 mb-2.5'>
                <button onClick={() => setResponsiveInventarioUI(!ResponsiveInventarioUI)} className='flex gap-2 bg-[#f34e00] py-2 px-3 rounded-full font-bold text-lgs'><BackIcon/>Volver</button>

                <button onClick={() => {
                  Generator()
                  setResponsiveInventarioUI(false)
                }} className='flex gap-2 rounded-full py-2 px-4 bg-[#f34e00] font-bold text-lgs'><BrainIcon/>Generar</button>

              </div>

              <div className='flex flex-col gap-2 w-full px-5 py-4 p-2 rounded-xl items-center h-fit max-h-[80%] overflow-y-scroll scrollbar-thin scrollbar-thumb-[#f34e00] hover:scrollbar-thumb-[#f34d00da] active:scrollbar-thumb-sky-300 scrollbar-track-slate-900 min-[700px]:grid min-[700px]:grid-cols-2'>

                {
                  inventario.map((item) => (
                    <Card key={item.id} ID={item.id} name={item.name} mount={item.mount} form={item.form} shop={Shop} setShop={setShop} inven={inventario} setInven={setInventario} />
                  ))
                }

              </div>
            </section>
          </div>
          <div className='absolute flex items-end w-fit  h-[85%] justify-start pl-4 mt-4'>
            <button onClick={HandleClickBackButtonToFormToGenerated} className={!Generated ? 'flex items-center gap-0.5 bg-[#f34d00da] rounded-full px-2 py-2 text-sm max-[1280px]:hidden' : 'flex items-center gap-0.5 bg-[#f34d00da] rounded-full px-2 py-2 text-sm'}><BackIcon/> Volver</button>
          </div>

          <div className={!Generated ? 'flex w-full h-[80%] justify-center items-center max-[1280px]:hidden' : 'hidden'}>
            <div className='flex flex-col items-center'>
              <h4 className='text-2xl p-4 text-center'>Escoja sus ingredientes y presione "Generar" para crear su planificación</h4>
              <button onClick={Generator} className='bg-[#f34d00da] p-2 rounded-xl text-xl font-semibold px-4'>GENERAR</button>
            </div>
          </div>

          <section className={Generated ? 'hidden' : 'mt-4 flex flex-col w-full h-[90%] min-[1280px]:hidden'}>

            <div className='w-full flex justify-between px-5 mb-2.5'>
              <button onClick={() => setResponsiveInventarioUI(!ResponsiveInventarioUI)} className='flex gap-2 bg-[#f34e00] py-2 px-3 rounded-full font-bold text-lgs'><ArchiveIcon/>{`Ver inventario (${inventario.length})`}</button>

              <button onClick={Generator} className='flex gap-2 rounded-full py-2 px-4 bg-[#f34e00] font-bold text-lgs'><BrainIcon/>Generar</button>

            </div>
            <h5 className='px-4 text-2xl mb-2 mt-2 text-center font-bold'>Escoge tus ingredientes</h5>

            <div className='flex justify-center'>
              <input type="search" name="" id="" placeholder='Buscar...' className='bg-[#313131] rounded-full w-11/12 mx-auto h-12 px-4 outline-none border-none' onChange={HandleSearch}/>
            </div>

            <div className='flex flex-col gap-2 w-full h-fit px-5 mt-3 max-h-[90%] overflow-y-scroll scrollbar-thin scrollbar-thumb-[#f34e00] hover:scrollbar-thumb-[#f34d00da] active:scrollbar-thumb-sky-300 scrollbar-track-slate-900 min-[700px]:grid min-[700px]:grid-cols-2'>

            {
              Shop.map((item) => (
                <ShopCard key={item.id} ID={item.id} name={item.name} mount={item.mount} form={item.form} shop={Shop} setShop={setShop} inven={inventario} setInven={setInventario}/>
              ))
            }

            </div>
          </section>

          <div className={Generated ? 'flex gap-2 items-center w-full justify-end pr-4 pt-1 max-[1280px]:justify-center' : 'hidden'}>
            <input onClick={HandleClickWantClockRecipe} value={WantClockRecipes} type="checkbox" name="" id="" /> <p>Mostrar recetas que casi puedes elaborar</p>
          </div>
          <div className={!WantClockRecipes && Generated ? 'grid grid-cols-3 h-[80%] overflow-y-auto gap-2 p-4 mt-5 max-[1280px]:grid-cols-1 scroll scrollbar-thin scrollbar-thumb-[#f34e00] hover:scrollbar-thumb-[#f34d00da] active:scrollbar-thumb-sky-300 scrollbar-track-slate-900 ' : 'hidden grid-cols-3 gap-2 p-4 '}>
            {FreeRecipes.map(recipe => (
              <RecipeCard key={recipe.id} name={recipe.name} ingredients={recipe.ingredientes} setReading={setReading} setReadRecipe={setReadRecipe}/>
            ))}
          </div>

          <div className={WantClockRecipes && Generated ? 'grid grid-cols-3 gap-2 h-[80%] p-4 mt-5 overflow-y-auto max-[1280px]:grid-cols-1 scroll scrollbar-thin scrollbar-thumb-[#f34e00] hover:scrollbar-thumb-[#f34d00da] active:scrollbar-thumb-sky-300 scrollbar-track-slate-900 ' : 'hidden grid-cols-1 gap-2 p-4'}>
            {ClockRecipes.map(recipe => (
              <RecipeCard key={recipe.id} recipe={recipe.clock} name={recipe.name} ingredients={recipe.ingredientes} setReading={setReading} setReadRecipe={setReadRecipe}/>
            ))}
          </div>
        </section>

        {/* Seccion de la derecha */}

        <section className='bg-[#353535] w-1/4 h-full rounded-3xl rounded-r-none p-6 max-xl:hidden'>
          <div className='flex justify-center'>
            <input type="search" name="" id="" placeholder='Buscar...' className='bg-[#272727] rounded-full h-12 px-4 outline-none border-none w-full' onChange={HandleSearch}/>
          </div>

          <div className='flex flex-col gap-2 w-full h-fit px-5 pt-4 mt-3 max-h-[90%] overflow-y-scroll scrollbar-thin scrollbar-thumb-[#f34e00] hover:scrollbar-thumb-[#f34d00da] active:scrollbar-thumb-sky-300 scrollbar-track-slate-900'>

            {
              Shop.map((item) => (
                <ShopCard key={item.id} ID={item.id} name={item.name} mount={item.mount} form={item.form} shop={Shop} setShop={setShop} inven={inventario} setInven={setInventario}/>
              ))
            }

          </div>
        </section>
      </section>
    </>
  )
}
